
import React, { useState } from 'react'
import { Container, Header, Icon, Comment, Grid, Image, Label, Rating, GridColumn, Divider } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import AccommodationReviews from '../../../components/AccommodationReviews/AccommodationReviews';
import AccommodationLocation from '../../../components/AccommodationLocation/AccommodationLocation';
import AccommodationHost from '../../../components/AccommodationHost/AccommodationHost';
import AccommodationRules from '../../../components/AccommodationRules/AccommodationRules';
import AccommodationPriceHistory from '../../../components/AccommodationPriceHistory/AccommodationPriceHistory';
import SimilarPlaces from '../../../components/SimilarPlaces/SimilarPlaces';

const Section3 = () => {
    const { t } = useTranslation();
    const data = [
        {
            img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',
            price: "4250000",
            beds: 2,
            baths: 2,
            area: 1089,
            address: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است."
        },
        {
            img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',
            price: "4250000",
            beds: 2,
            baths: 2,
            area: 1089,
            address: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است."
        },
        {
            img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',
            price: "4250000",
            beds: 2,
            baths: 2,
            area: 1089,
            address: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است."
        },
        {
            img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',
            price: "4250000",
            beds: 2,
            baths: 2,
            area: 1089,
            address: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است."
        },
        {
            img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',
            price: "4250000",
            beds: 2,
            baths: 2,
            area: 1089,
            address: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است."
        },

    ]

    return (
        <Container className="bg-white" id="property-section3">
            <AccommodationReviews />
            <Divider />
            <AccommodationLocation />
            <Divider />
            <AccommodationHost />
            <Divider />
            <AccommodationRules />
            <Divider />
            <AccommodationPriceHistory />
            <Divider />
            <SimilarPlaces data={data} />
        </Container>

    )
}
export default Section3